import store from '@root/src/javascripts/store'

const stepConditions = {
  InsuranceRequestStart: (_) => !!store.state.newContract.insurance.startOfInsurance
           && (store.state.newContract.customerType === 'company'
            || !!store.state.newContract.personal.age)
           && !!store.state.newContract.personal.zip
           && (!!store.state.newContract.personal.nationality || store.state.newContract.customerType === 'company')
           && !!store.state.newContract.vehicle.initialRegistrationYear
           && ((!!store.state.newContract.vehicle.brand
            && !!store.state.newContract.vehicle.model)
            || !!store.state.newContract.vehicle.typeCertificateNumber),
  ProductSelect: (_) => !!store.state.newContract.insurance.productVersionId,
  Options: (_) => store.state.newContract.tariffOptions !== null
           && typeof store.state.newContract.tariffOptions === 'object'
           && Object.keys(store.state.newContract.tariffOptions).length > 0
           && !!store.state.newContract.insurance.paymentInterval,
  VehicleSelect: (_) => !!store.state.newContract.vehicle.id,
  VehicleData: (_) => !!store.state.newContract.vehicle.ownedSince
           && !!store.state.newContract.vehicle.canton
           && store.state.newContract.vehicle.leasing !== null
           && store.state.newContract.vehicleUsage.business !== null
           && store.state.newContract.vehicleUsage.transport !== null,
  Owner: (_) => ((!['CH', 'LI'].includes(store.state.newContract.personal.nationality) && !!store.state.newContract.personal.residencePermit) || ['CH', 'LI'].includes(store.state.newContract.personal.nationality) || store.state.newContract.customerType === 'company')
           && (store.state.newContract.customerType === 'company'
            || !!store.state.newContract.personal.driverLicenceSinceYear)
           && store.state.newContract.insurance.isKeeperMainDriver !== null
           && (!!store.state.newContract.insurance.genderOfTooYoungDriver
            || (store.state.newContract.insurance.genderOfTooYoungDriver === null
            && !store.state.newContract.insurance.isDriverTooYoung))
           && store.state.newContract.insurance.driverLicenceWithdrawal !== null
           && store.state.newContract.insurance.claims !== null
           && !!store.state.newContract.insurance.isDriverTooYoung !== null,
  PersonalData: (_) => !!store.state.newContract.personal.gender
           && ((store.state.newContract.customerType === 'company'
            && !!store.state.newContract.personal.company)
            || (!!store.state.newContract.personal.firstName
            && !!store.state.newContract.personal.lastName
            && !!store.state.newContract.personal.dateOfBirth))
           && !!store.state.newContract.personal.street
           && !!store.state.newContract.personal.houseNumber
           && !!store.state.newContract.personal.zip
           && !!store.state.newContract.personal.city
           && !!store.state.newContract.personal.email
           && !store.state.newContract.declinedReason,
}

const ensureStepCondition = (steps) => {
  let result = ''
  let invalid = false

  steps.forEach((step) => {
    if (!invalid) {
      // eslint-disable-next-line no-prototype-builtins
      if (stepConditions.hasOwnProperty(step) && !stepConditions[step]()) {
        result = step
        invalid = true
      }
    }
  })

  return result
}

export default ensureStepCondition
